<app-header></app-header>

<section class="inerpages-banner arabic">
  <img src="{{ imgurl }}{{ orderOnlineBanner['picture'] }}" class="w-100" />
  <div class="fade-bg"></div>
  <div class="mask-content-v-center text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="tbox-iner text-center animate" data-anim-type="zoomIn">
            <div class="heading-iner">
              <h2 *ngIf="showLang == 'en'">
                {{ orderOnlineBanner["smallCaption"] }}
              </h2>
              <h2 *ngIf="showLang == 'ar'">
                {{ orderOnlineBanner["smallCaption_ar"] }}
              </h2>

              <hr />
              <p *ngIf="showLang == 'en'">
                {{ orderOnlineBanner["bigCaption"] }}
              </p>
              <p *ngIf="showLang == 'ar'">
                {{ orderOnlineBanner["bigCaption_ar"] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="order-online animate fadeInUp" data-anim-type="fadeInUp">
  <div class="container-fluid">
    <div class="row discover_products">
      <div class="heading_secs col-sm-5 col-md-3">
        <div class="row">
          <div class="col-md-12 heading">
            <h4>{{ "HOME.MENU" | translate }}</h4>
          </div>
        </div>

        <div class="row">
          <div class="scroll-cate d-md-none">
            <div class="menu_box" *ngFor="let ct of cats">
              <div class="card h-100">
                <a [routerLink]="['/order-online/cats/', ct.cslug]" *ngIf="!ct.hasSubcat">
                  <img class="img-fluid w-100" src="{{ imgurl }}{{ ct.cimage }}" alt="{{ ct.cname }}"/>
                  <div class="card-body align-items-center">
                    <p class="card-text" *ngIf="showLang == 'en'">{{ ct.cname }}</p>
                    <p class="card-text" *ngIf="showLang == 'ar'">{{ ct.cname_ar }}</p>
                  </div>
                </a>

                <a [routerLink]="['/order-online/subcats/', ct.cslug]" *ngIf="ct.hasSubcat">
                  <img class="img-fluid w-100" src="{{ imgurl }}{{ ct.cimage }}" alt="{{ ct.cname }}"/>
                  <div class="card-body align-items-center">
                    <p class="card-text" *ngIf="showLang == 'en'">{{ ct.cname }}</p>
                    <p class="card-text" *ngIf="showLang == 'en'">{{ ct.cname_ar }}
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="row d-md-flex d-none">
          <div class="col-md-6 col-6 menu_box" *ngFor="let ct of cats">
            <div class="card h-100">
              <a [routerLink]="['/order-online/cats/', ct.cslug]" *ngIf="!ct.hasSubcat">
                <img class="img-fluid w-100" src="{{ imgurl }}{{ ct.cimage }}" alt="{{ ct.cname }}"/>
                <div class="card-body align-items-center">
                  <p class="card-text" *ngIf="showLang == 'en'">{{ ct.cname }}</p>
                  <p class="card-text" *ngIf="showLang == 'ar'">{{ ct.cname_ar }}</p>
                </div>
              </a>

              <a [routerLink]="['/order-online/subcats/', ct.cslug]" *ngIf="ct.hasSubcat">
                <img class="img-fluid w-100" src="{{ imgurl }}{{ ct.cimage }}" alt="{{ ct.cname }}"/>
                <div class="card-body align-items-center">
                  <p class="card-text" *ngIf="showLang == 'en'">{{ ct.cname }}</p>
                  <p class="card-text" *ngIf="showLang == 'en'">{{ ct.cname_ar }}
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="products_secs details-page col-sm-7 col-md-9">
        <div class="col-md-12 text-center my-4" *ngIf="isLoading">
          <span class="lodercont">
            <app-refreshloader></app-refreshloader>
          </span>
        </div>

        <nav aria-label="breadcrumb ">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="/">{{ "HOME.HOME" | translate }}</a>
            </li>
            <li class="breadcrumb-item" *ngIf="showLang == 'en'">
              <a [routerLink]="['/order-online/cats/', catslug]">{{
                catname | uppercase
              }}</a>
            </li>
            <li class="breadcrumb-item" *ngIf="showLang == 'ar'">
              <a [routerLink]="['/order-online/cats/', catslug]">{{
                catname_ar | uppercase
              }}</a>
            </li>
            <li
              class="breadcrumb-item active"
              aria-current="page"
              *ngIf="showLang == 'en'"
            >
              {{ productAr.pName | uppercase }}
            </li>
            <li
              class="breadcrumb-item active"
              aria-current="page"
              *ngIf="showLang == 'ar'"
            >
              {{ productAr.pName_ar | uppercase }}
            </li>
          </ol>
        </nav>

        <h2 class="main-heading" *ngIf="showLang == 'en'">
          {{ productAr.pName }}
        </h2>
        <h2 class="main-heading" *ngIf="showLang == 'ar'">
          {{ productAr.pName_ar }}
        </h2>
        <div class="product-details mb-3">
          <div class="card">
            <div class="container-fliud">
              <div class="row">
                <div class="col-md-4">
                  <a
                    href="javacript:void(0)"
                    (click)="addtoWishlist(productAr.id)"
                  >
                    <span
                      class="fa fa-heart heart-icon"
                      *ngIf="wishlistProductId === null"
                    ></span>
                    <span
                      class="fa fa-heart heart-icon red"
                      *ngIf="wishlistProductId == 'yes' || iswishlist == true"
                    ></span>
                  </a>

                  <img
                    class="w-100 img-fluid"
                    src="{{ imgurl }}{{ productAr.pImage }}"
                    alt="{{ productAr.pName }}"
                  />

                  <div class="mt-4" *ngIf="productAr.allingredients != ''">
                    <div class="option ingred-sec mb-2 mb-md-3">
                      <table class="table">
                        <thead>
                          <tr>
                            <td></td>
                            <td class="text-center">
                              <h5>
                                {{ "product_detail.regular" | translate }}
                              </h5>
                            </td>
                            <td class="text-center">
                              <h5>{{ "product_detail.less" | translate }}</h5>
                            </td>
                            <td class="text-center">
                              <h5>
                                {{ "product_detail.without" | translate }}
                              </h5>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                        
                          <tr *ngFor="let ing of productAr.allingredients; let j = index">
                            <td scope="row">
                              <h6 *ngIf="showLang == 'en'">
                                {{ ing.ingName }}
                              </h6>
                              <h6 *ngIf="showLang == 'ar'">
                                {{ ing.ingNameAr }}
                              </h6>
                            </td>

                            <td class="text-center">
                              <input
                                class="form-check-input"
                                checked
                                type="radio"
                                name="ing{{ ing.id }}"
                                id="ing_{{ j }}"
                                [attr.ischecked]="'no'"
                                appIngrdradio
                                [attr.pid]="productAr.id"
                                [attr.gradeName]="ing.ingName"
                                [attr.gradeid]="ing.id"
                                value="Regular"
                                (change)="checkGradient(inGrade)"
                                #inGrade
                              />
                            </td>
                            <td class="text-center">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="ing{{ ing.id }}"
                                id="ing2_{{ j }}"
                                [attr.ischecked]="'no'"
                                appIngrdradio
                                [attr.pid]="productAr.id"
                                [attr.gradeName]="ing.ingName"
                                [attr.gradeid]="ing.id"
                                value="Less"
                                (change)="checkGradient(inGrade2)"
                                #inGrade2
                              />
                            </td>
                            <td class="text-center">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="ing{{ ing.id }}"
                                id="ing3_{{ j }}"
                                [attr.ischecked]="'no'"
                                appIngrdradio
                                [attr.pid]="productAr.id"
                                [attr.gradeName]="ing.ingName"
                                [attr.gradeid]="ing.id"
                                value="Without"
                                (change)="checkGradient(inGrade3)"
                                #inGrade3
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="details col-md-8">
                  <p *ngIf="showLang == 'en'">{{ productAr.pdescription }}</p>
                  <p *ngIf="showLang == 'ar'">
                    {{ productAr.pdescription_ar }}
                  </p>
                    <div class="d-block overflow-hidden">
                      <label class="mr-3 mt-3 mt-md-0 d-block" for="quantity">{{
                        "product_detail.quantity" | translate
                      }}</label>
                      <!-- <input type="number" min="1" value="1" id="quantity" class="form-control mx-sm-2" #qty> -->
                      <!-- <span class="price"> 20 AED </span> -->
                      <button
                        class="qtybtnmin"
                        (click)="desQty(qty, baseprice)"
                      >
                        -
                      </button>
                      <div class="qty">{{ qty }}</div>
                      <button
                        class="qtybtnplus"
                        (click)="incQty(qty, baseprice, productAr.pQty)"
                      >
                        +
                      </button>
                    </div>

 
                <p *ngIf="errorMessagePopCheckbox" class="text-danger mt-4 mb-2">
                  {{ errorMessagePopCheckbox }}
                </p>
                  <div class="row my-4">
                
                    <div class="col-md-6" *ngIf="productAr.poptions != ''">
                     
                      <div class="option optioncnt  mb-2 mb-md-3" *ngFor="let optn of productAr.poptions; let i = index">
                        <h6 *ngIf="showLang == 'en'">
                          {{ optn.option_display_name }}
                        </h6>
                        <h6 *ngIf="showLang == 'ar'">
                          {{ optn.option_display_name_ar }}
                        </h6>
                      <div *ngIf="displName == optn.option_display_name ">
                      <p *ngIf="minQtyMsg" style="font-size: 13px;" class="text-danger mt-2 text-sm">
                        {{ minQtyMsg }}
                      </p>
                      </div>
                      
                        <div class="form-check mb-2 optncnt" *ngFor="let opv of optn.poptionvalues">
                          <input
                            type="radio"
                            class="form-check-input optnchk"
                            *ngIf="optn.isMultiSelect != 1"
                            [attr.ischecked]="'no'"
                            appRadioclick
                            name="optn{{ optn.id }}"
                            id="opv{{ opv.id }}"
                            [attr.optnname]="optn.option_name"
                            [attr.optnname_ar]="optn.option_display_name_ar"
                            [attr.optnid]="optn.id"
                            [attr.optnvalue]="opv.ovalue"
                            [attr.optnvalue_ar]="opv.ovalue_ar"
                            [attr.pid]="productAr.id"
                            [attr.price]="opv.ovprice"
                            [attr.qty]="optn.isRestricted == 1 ? 0 : 1"
                            [attr.pvalue]="opv.id"
                            value="{{ opv.id }}"
                            (change)="chkoptvl(optvl)"
                            #optvl
                          />

                          <input  
                            type="checkbox"
                            class="form-check-input optnchk"
                            *ngIf="optn.isMultiSelect == 1"
                            name="optn{{ opv.id }}"
                            id="opv{{ opv.id }}"
                            [attr.optnname]="optn.option_name"
                            [attr.optnname_ar]="optn.option_display_name_ar"
                            [attr.optnid]="optn.id"
                            [attr.optnvalue]="opv.ovalue"
                            [attr.optnvalue_ar]="opv.ovalue_ar"
                            [attr.pid]="productAr.id"
                            [attr.price]="opv.ovprice"
                            [attr.qty]="optn.isRestricted == 1 ? 0 : 1"
                            [attr.pvalue]="opv.id"
                            value="{{ opv.id }}"
                            (change)="chkoptvl(optvl2)"
                            #optvl2
                          /> 

                          <form class="quantity quantityfrm" >
                            <label class="form-check-label mb-1" for="opv{{ opv.id }}">
                              <span *ngIf="showLang == 'en'">{{opv.ovalue}}</span>
                              <span *ngIf="showLang == 'ar'">{{opv.ovalue_ar}}</span>
                              <span *ngIf="opv.ovprice != 0">+ AED {{ opv.ovprice }}</span>
                            </label>

                            <div class="form-group overflow-hidden mb-0 indeccnt" *ngIf="optn.isRestricted == 1">
                              <button appVariationbtn [dAction]="'substract'"  class="qtybtnmin qtybtn">-</button>
                              <span class="qty optnqty">0</span>
                              <button appVariationbtn [dAction]="'add'" class="qtybtnplus qtybtn">+</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                   
                    <div class="col-md-6" *ngIf="productAr.padons != ''">
                    
                      <div class="option mb-2 mb-md-3" *ngFor="let adns of productAr.padons">
                   
                        <h6 *ngIf="showLang == 'en'">{{ adns.adonDisName }}</h6>
                        <h6 *ngIf="showLang == 'ar'">
                          {{ adns.adonDisName_ar }}
                        </h6>
                        
                        <div
                          class="form-check overflow-hidden mb-2"
                          *ngFor="let adnv of adns.padonvalues"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="adon{{ adnv.id }}"
                            [attr.adonname]="adns.adonName"
                            [attr.adonname_ar]="adns.adonName_ar"
                            [attr.adonid]="adns.id"
                            [attr.valuename]="adnv.adonValue"
                            [attr.valuename_ar]="adnv.adonValue_ar"
                            [attr.valueid]="adnv.id"
                            [attr.pid]="productAr.id"
                            [attr.qty]="qty"
                            value="{{ adnv.adonPrice }}"
                            (change)="chkadonvl(adonvl)"
                            #adonvl
                          />
                          <label
                            class="form-check-label"
                            for="adon{{ adnv.id }}"
                          >
                            <span *ngIf="showLang == 'en'">{{
                              adnv.adonValue
                            }}</span>
                            <span *ngIf="showLang == 'ar'">{{
                              adnv.adonValue_ar
                            }}</span>
                            <span> + AED {{ adnv.adonPrice }} </span>
                          </label>
                        </div>
                      </div> 
                    </div>
                  </div>

                  <div class="row" *ngIf="productAr.isFeast == 1">
                    <div class="col-md-6">
                      <label class="addi-text" for=""
                        >{{ "product_detail.select_from_time" | translate }}
                      </label>
                      <input
                        type="date"
                        class="form-control date-from"
                        name="dl_date"
                        (change)="getDate(date.value)"
                        placeholder="Choose date"
                        #date
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="addi-text" for="">{{
                        "product_detail.select_delivery_time" | translate
                      }}</label>
                      <select
                        name="from_time"
                        class="form-control date-from"
                        (change)="getfromTime(fromtime.value)"
                        #fromtime
                      >
                        <option value="">Time</option>
                        <option *ngFor="let timing of timings" [value]="timing">
                          {{ timing }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <p *ngIf="schMsg != '' && showLang == 'en'" class="text-danger valid-danger-text mt-3">
                    {{ schMsg }}</p>
                  <p *ngIf="schMsg != '' && showLang == 'ar'" class="text-danger valid-danger-text mt-3">
                    {{ schMsg_ar }}
                  </p>

                  <div class="action">
                    <p class="total mb-0">
                      {{ "product_detail.total" | translate }}
                    </p>
                    <p class="total-price">AED {{ finalprice }}</p>
                    <label class="addi-text">{{
                      "product_detail.add_info" | translate
                    }}</label>

                    <div *ngIf="productAr.id == 239; else showBtnord">
                      <div *ngIf="productAr.isActive == 0; else showordMsg">
                        <h4 class="msgprd-newyr">
                          This product will be available to order between 31 Dec
                          2020 TO 2 Jan 2021
                        </h4>
                      </div>

                      <ng-template #showordMsg>
                        <input
                          placeholder="{{
                            'product_detail.enter_here' | translate
                          }}"
                          type="text"
                          class="form-control addi-input"
                          #coment
                        />
                        <button type="button"*ngIf="productAr.out_stock == 0" class="add-to-cart btn btn-default mt-4"
                          (click)="addtoCart(
                              productAr.pName,
                              productAr.id,
                              productAr.price,
                              finalprice,
                              qty,
                              productAr.pImage,
                              productAr.pName_ar,
                              coment.value,
                              productAr.pQty,
                              productAr.isFeast
                            )">
                          <i class="fab fa-opencart"></i>
                          {{ "product_detail.addtocart" | translate }}
                        </button>
                      </ng-template>
                    </div>
                    <ng-template #showBtnord>
                      <input
                        placeholder="{{
                          'product_detail.enter_here' | translate
                        }}"
                        type="text"
                        class="form-control addi-input"
                        #coment
                      />
                      <button
                        *ngIf="productAr.out_stock == 0"
                        class="add-to-cart btn btn-default mt-4"
                        (click)="
                          addtoCart(
                            productAr.pName,
                            productAr.id,
                            productAr.price,
                            finalprice,
                            qty,
                            productAr.pImage,
                            productAr.pName_ar,
                            coment.value,
                            productAr.pQty,
                            productAr.isFeast
                          )"
                        type="button"
                      >
                        <i class="fab fa-opencart"></i>
                        {{ "product_detail.addtocart" | translate }}
                      </button>
                    </ng-template>
                    <p *ngIf="minQtyMsg" style="font-size: 13px;" class="text-danger mt-2 text-sm">
                      {{ minQtyMsg }}
                    </p> 
                  </div>

                  <p class="out-stock" *ngIf="productAr.out_stock == 1">
                    {{ "cart.out_stock" | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<button
  type="button"
  [hidden]="true"
  class="btn btn-primary btn-sm"
  data-toggle="modal"
  data-target="#modalPopup"
  #cmodel
></button>

<!-- Modal -->
<div
  class="modal alert-modal fade"
  id="modalPopup"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body text-center">
        <p *ngIf="showLang == 'en'">{{ cartMsg }}</p>
        <p *ngIf="showLang == 'ar'">{{ cartMsg_ar }}</p>
      </div>
    </div>
  </div>
</div>